import React from 'react'

const Footer = (props) => {
    return (
        <div className='bg-black text-white py-8 md:py-9 lg:py-[0.9842rem] xl:py-[1.96rem]'>
            <h1 className='font-bold text-3xl sm:text-lg md:text-xl lg:text-2xl text-center'>Copyright &copy; 2022 {props.name}</h1>
        </div>
    )
}

export default Footer;
